exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-icon{width:100%;height:160px;margin:0 auto;background-size:contain;background-position:bottom}.category-card:hover{color:#ddd!important;background-color:#100429!important}.category-card:hover .category-icon{opacity:.75}", ""]);

// exports
